import { Injectable } from '@angular/core';
import { Timer } from 'libraries/Timer';

@Injectable()
export class UserIdleService {
	public waitingAuth: boolean;
	private inactivityTimer: Timer;
	private writeExpirationDate: Date;
	private writeMsLeft: number;
	public writeTimeLeft: string;
	private readExpirationDate: Date;
	private readMsLeft: number;
	public readTimeLeft: string;
	private timer: Timer;
	private callback: any;
	constructor() {}

	setIddleService(readExpiration: Date, writeExpiration: Date, callback: any) {
		this.readExpirationDate = readExpiration;
		this.writeExpirationDate = writeExpiration;

		var readTimeLeft = readExpiration.getTime() - new Date().getTime();

		let writeTimeLeft = 0;
		if (writeExpiration) {
			writeTimeLeft = writeExpiration.getTime() - new Date().getTime();
		}

		//this.inactivityTimer = new Timer(readTimeLeft, callback);
		this.callback = callback;
		this.readMsLeft = readTimeLeft;
		this.writeMsLeft = writeTimeLeft;

		this.timer = new Timer(1000, this.updateTimeLeft.bind(this));

		this.updateTimeLeft();
	}

	start() {
		//this.inactivityTimer.start();
		this.timer.start();
	}

	stop() {
		this.timer.stop();
		//this.inactivityTimer.stop();
	}

	restart() {
		this.timer.restart();
		//this.inactivityTimer.restart();
	}

	updateTimeLeft() {
		this.readMsLeft = this.readExpirationDate.getTime() - new Date().getTime();
		this.readTimeLeft = this.parseMillisecondsIntoReadableTime(this.readMsLeft);

		if (this.writeExpirationDate) {
			this.writeMsLeft = this.writeExpirationDate.getTime() - new Date().getTime();
		} else {
			this.writeMsLeft = 0;
		}
		this.writeTimeLeft = this.parseMillisecondsIntoReadableTime(this.writeMsLeft);
		if (this.readMsLeft < 2000) {
			this.readTimeLeft = 'expired';
			this.callback();
		}
		if (this.writeMsLeft < 1000) {
			this.writeTimeLeft = 'expired';
		}
	}

	// msToTime(duration) {
	//   var milliseconds = ((duration / 1000) / 100);
	//   var seconds = ((duration / 1000) / 60);
	//   var minutes = ((duration / (1000 * 60)) / 60);
	//   var hours = ((duration / (1000 * 60 * 60)) / 24);
	//   var t=1;
	//   var h:string;

	//   var shours = (hours < 10) ? "0" + hours : hours.toString();
	//   var sminutes = (minutes < 10) ? "0" + minutes : minutes.toString();
	//   var sseconds = (seconds < 10) ? "0" + seconds : seconds.toString();

	//   return parseInt(shours,10) + ":" + parseInt(sminutes,10) + ":" + parseInt(sseconds,10) + ".";
	// }
	parseMillisecondsIntoReadableTime(milliseconds) {
		//Get hours from milliseconds
		var hours = milliseconds / (1000 * 60 * 60);
		var absoluteHours = Math.floor(hours);
		var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

		//Get remainder from hours and convert to minutes
		var minutes = (hours - absoluteHours) * 60;
		var absoluteMinutes = Math.floor(minutes);
		var m = absoluteMinutes > 9 ? absoluteMinutes : '0' + absoluteMinutes;

		//Get remainder from minutes and convert to seconds
		var seconds = (minutes - absoluteMinutes) * 60;
		var absoluteSeconds = Math.floor(seconds);
		var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

		return h + ':' + m + ':' + s;
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/user-idle/user-idle.service.ts